var MissingFieldError = (function () {
    function MissingFieldError(message, path, query, variables) {
        this.message = message;
        this.path = path;
        this.query = query;
        this.variables = variables;
    }
    return MissingFieldError;
}());
export { MissingFieldError };
//# sourceMappingURL=common.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/cache/core/types/common.js
// module id = ./node_modules/@apollo/client/cache/core/types/common.js
// module chunks = 54 55